import { Text } from '@leroy-merlin-br/backyard-react'

import { AlertMessage } from 'shared/components/AlertMessage'

const ResponsibleAbsent = () => (
  <AlertMessage type="warning">
    <Text as="strong" size="kilo" isBold noMargin>
      Tentamos entregar seu pedido
    </Text>
    , mas infelizmente não foi possível encontrar alguém para receber sua
    compra. Faremos uma nova tentativa no{' '}
    <Text as="strong" size="kilo" isBold noMargin>
      próximo dia útil
    </Text>
    .
  </AlertMessage>
)

export default ResponsibleAbsent
